import React, { useState, useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';
import TradesComponent from "../components/TradesComponent"
interface ValidationErrors {
  apiKey?: string;
  amountForEachTrade?: string;
}
const String_REGEX = /^[A-Za-z\s]+$/;
const Number_REGEX = /^[0-9\s]+$/;

const Bot: React.FC = () => {
  const {
    user
  } = useUserContext();
  const [apiKey, setApiKey] = useState("")
  const [amountForEachTrade, setAmountForEachTrade] = useState("")
  const [maxDailyLoss, setMaxDailyLoss] = useState("");
  const [error, setError] = useState('');
  const [validationErrors, setValidationErrors] = useState<ValidationErrors>({});
  const [isFormValid, setIsFormValid] = useState(false);

  // Validate form fields on input change
  useEffect(() => {
    const errors: ValidationErrors = {};

    //apiKey validation
    if (apiKey) {
      if (!String_REGEX.test(apiKey)) {
        errors.apiKey = 'API Key must contain only letters and numbers';
      }
    }

    //amountForEachTrade validation
    if (amountForEachTrade) {
      if (Number(amountForEachTrade) <= 0) {
        errors.amountForEachTrade = 'Amount must be greater than 0';
      } else if (!Number_REGEX.test(amountForEachTrade)) {
        errors.amountForEachTrade = 'Name must contain only letters and spaces';
      }
    }

    setValidationErrors(errors);

    // Check if form is valid (all fields have values and no validation errors)
    setIsFormValid(
      apiKey.trim() !== '' &&
      amountForEachTrade.trim() !== ''
    );
  }, [apiKey, amountForEachTrade]);

  const openInNewTab = () => {
    const newWindow = window.open(
      'https://www.binance.com/en/support/faq/detail/96dde1d806a44a67924f322f4f8092f6',
      '_blank',
      'noopener,noreferrer'
    );
    if (newWindow) newWindow.opener = null;
  };

  const saveBotConfig = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    // Double-check validation before submission
    if (!isFormValid) {
      setError('Please correct all validation errors before submitting');
      return;
    }
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/dashboard/saveBotConfig", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ apiKey, amountForEachTrade }),
      });
      const data = await response.json();

      if (!response.ok) {
        alert("Error")
      }
    } catch (err) {
      setError('An error occurred while saving Bot Config');
      console.error(err);
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <main className="flex-1 p-0">
        <header className="mb-6">
          <h1 className="text-2xl font-bold">Trades</h1>
        </header>

        {user.pricing == "Pro" || user.pricing == "Enterprise" ?
          <div>

            {user?.email ?
              <TradesComponent user={user} />
              : null}
          </div>
          : null}
      </main>
    </div>




  );
};

export default Bot;
